import React from 'react';
import { useTranslation } from 'react-i18next';


function StatCard({ label, value, icon, color, hint, detail, detailClassName = 'text-gray-600' }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 sm:p-4 hover:shadow-md transition-shadow relative min-h-[76px] sm:min-h-[90px] pr-10 sm:pr-14">
      <p className="text-gray-500 text-[11px] sm:text-sm font-medium leading-snug break-words pr-1">{label}</p>
      <p className="text-base sm:text-xl font-bold text-gray-900 mt-1 break-words">{value}</p>
      {hint ? <p className="text-[11px] sm:text-xs text-gray-500 mt-0.5 pr-1">{hint}</p> : null}
      {detail ? <p className={`text-[11px] sm:text-xs font-medium mt-1 pr-1 ${detailClassName}`}>{detail}</p> : null}
      <div className={`p-1.5 sm:p-2 absolute rounded-lg right-2 bottom-2 sm:right-3 sm:bottom-3 ${color}`}>
        {icon}
      </div>
    </div>
  );
}

export default StatCard;
